module.exports = __webpack_public_path__ + "static/media/seed4.24a24bcd.png";